module.exports = __webpack_public_path__ + "static/media/info-4.1b62b34c.png";